<p-toast position="top-right"></p-toast>
<div class="container-fluid">
  <div class="card-panel mt-5">
    <div class="row">
      <div class="col-md-8">
        <lib-page-header page-title="TRANSFERÊNCIAS BANCÁRIA"
          page-subtitle="EXERCÍCIO: {{login.exercicio.ano}} - {{login['ppa']['descricao']}}"
          image-title="assets/img/payment-method.png">
        </lib-page-header>
      </div>
      <div class="col-md-4">
        <a (click)="voltar()" class="btn btn-sm btn-outline-secondary float-right  ml-5">
          <img src="assets/img/global/cross.png" alt="sair" title="Sair" height="20" width="20">
        </a>
        <lib-export-list (acao)="exportarListagem($event)"></lib-export-list>
        <a *ngIf="podeIncluir()" [routerLink]="['/transferencias-bancarias/novo']"
          class="btn btn-sm btn-outline-success float-right">
          <img src="assets/img/global/plus.png" alt="novo" class="mr-2" title="Incluir" height="20" width="20">Novo
        </a>
      </div>
    </div>
    <hr class="mt-1 mb-4" />
    <div class="row">
      <div class="col-md-5">
        <lib-filtro [(filtro)]="filtro" (localizaClick)="onClick($event)" (localizaKeydown)="onClick($event)">
        </lib-filtro>
      </div>
    </div>
    <div class="row">
      <div class="col-md">
        <table class="table table-eddy">
          <thead>
            <tr>
              <th scope="col" class="text-center">Data</th>
              <th scope="col">Conta Pagadora</th>
              <th scope="col">Conta Recebedora</th>
              <th scope="col" class="text-right">Valor</th>
              <th scope="col" style="width: 90px;"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of lista">
              <td class="text-center">{{item.data_transfere | date:'dd/MM/yyyy':'GMT'}}</td>
              <td>
                {{item.conta_pagadora.numero_conta}} {{item.conta_pagadora.banco.nome}} {{item.conta_pagadora.nome}}<br>
                <span class="text-black-50" style="font-size: 11px;">{{item.conta_pagadora.orgao.nome}}</span>
              </td>
              <td>
                {{item.conta_recebedora.numero_conta}} {{item.conta_pagadora.banco.nome}} {{item.conta_recebedora.nome}}<br>
                <span class="text-black-50" style="font-size: 11px;">{{item.conta_recebedora.orgao.nome}}</span>
              </td>
              <td class="text-right">{{item.valor_transferido | number:'1.2-2'}}</td>
              <td class="text-right" style="min-width: 100px;">
                <button [routerLink]="['/transferencias-bancarias', item.id, 'visualizar']"
                  *ngIf="!podeIncluir() || !podeAlterar(item.data_transfere)" routerLinkActive="router-link-active"
                  class="btn btn-sm btn-outline-secondary mr-2">
                  <img src="assets/img/global/zoom.png" alt="visualizar" height="16" width="16">
                </button>
                <button [routerLink]="['/transferencias-bancarias', item.id, 'editar']"
                  routerLinkActive="router-link-active" *ngIf="podeIncluir() && podeAlterar(item.data_transfere)"
                  class="btn btn-sm btn-outline-primary mr-2">
                  <img src="assets/img/global/pencil.png" alt="editar" height="16" width="16">
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row float-right" *ngIf="lista && lista.length > 0">
      <div class="col-12 mb-5">
        <lib-paginacao [(paginaCorrente)]="paginaCorrente" [(paginaTotal)]="paginaTotal"
          (paginaAnterior)="paginaAnterior()" (proximaPagina)="proximaPagina()"></lib-paginacao>
      </div>
    </div>
    <br>
    <br>
  </div>
</div>